import { debounce } from 'lodash-es';

export function easyThere<T extends (...args: Array<unknown>) => unknown>(fn: T) {
  return debounce(fn, 500, { leading: true, trailing: false });
}

export function omitUndefinedValues<T extends object>(params: T) {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined));
}

// biome-ignore lint/suspicious/noSelfCompare: always true for testing
export const ALWAYS_TRUE = 1 === 1;
